import { render, staticRenderFns } from "./DealersItem.vue?vue&type=template&id=47e7dd00&scoped=true&"
import script from "./DealersItem.vue?vue&type=script&lang=js&"
export * from "./DealersItem.vue?vue&type=script&lang=js&"
import style0 from "./DealersItem.vue?vue&type=style&index=0&id=47e7dd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7dd00",
  null
  
)

export default component.exports